import e from"styled-components";const t=e.div`
	display: grid;
	grid-template-columns: 1.7fr 1fr 1fr;
	align-items: center;
	column-gap: 8px;
`,i=e.div`
	display: flex;
	align-items: center;
	column-gap: ${({isTemplate:e})=>e?"7.7px":"12px"};
`,o=e.img`
	width: ${({isTemplate:e})=>e?"21px":"32px"};
	height: ${({isTemplate:e})=>e?"21px":"32px"};
	border-radius: 50%;
	object-fit: cover;
	object-position: center;
`,l=e.h1`
	all: unset;
	color: ${({theme:e})=>e.text.title};
	font-size: ${({isTemplate:e})=>e?"11px":"18px"};

	font-style: normal;
	font-weight: 600;
	line-height: ${({isTemplate:e})=>e?"14px":"25.887px"};
`,p=e.h2`
	all: unset;
	color: ${({color:e})=>e};
	font-size: 14px;
	font-size: ${({isTemplate:e})=>e?"9px":"14px"};

	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"12px":"19px"};
`,n=e.div`
	border-radius: 100px;
	background: ${({backgroundColor:e,theme:t})=>e||t.border.black10};
	display: flex;
	padding: 5px 10px;

	color: ${({color:e,theme:t})=>e||t.text.title};
	font-size: 13px;
	font-style: normal;
	font-weight: 500;
	line-height: 16px;
	text-align: right;
	justify-self: end;
`;export{i as CardAvatarAndName,t as CardContent,n as Label,o as PeopleAvatar,l as PeopleName,p as PeopleSubtitle};
